'use client';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

import { determineLocale } from '@/lib/determineLocale';

const GlobalError = ({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) => {
	const router = useRouter();

	useEffect(() => {
		const locale = determineLocale();
		router.push(`/${locale}`);
	}, []);
	return (
		// global-error must include html and body tags
		<html>
			<body>
				<h2>Something went wrong!</h2>
				<button onClick={() => reset()}>Try again</button>
			</body>
		</html>
	);
};

export default GlobalError;
